<template>
    <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_9456_169739)">
            <path
                d="M2 11.9556C2 8.47078 2 6.7284 2.67818 5.39739C3.27473 4.22661 4.22661 3.27473 5.39739 2.67818C6.7284 2 8.47078 2 11.9556 2H20.0444C23.5292 2 25.2716 2 26.6026 2.67818C27.7734 3.27473 28.7253 4.22661 29.3218 5.39739C30 6.7284 30 8.47078 30 11.9556V20.0444C30 23.5292 30 25.2716 29.3218 26.6026C28.7253 27.7734 27.7734 28.7253 26.6026 29.3218C25.2716 30 23.5292 30 20.0444 30H11.9556C8.47078 30 6.7284 30 5.39739 29.3218C4.22661 28.7253 3.27473 27.7734 2.67818 26.6026C2 25.2716 2 23.5292 2 20.0444V11.9556Z"
                fill="white"
            />
            <path
                d="M22.0513 8.52295L16.0642 13.1954L9.94019 8.52295V8.52421L9.94758 8.53053V15.0732L15.9951 19.8466L22.0513 15.2575V8.52295Z"
                fill="#EA4335"
            />
            <path
                d="M23.6235 7.38639L22.0511 8.52292V15.2575L26.9987 11.459V9.17074C26.9987 9.17074 26.3981 5.90258 23.6235 7.38639Z"
                fill="#FBBC05"
            />
            <path
                d="M22.0511 15.2575V23.9924H25.8432C25.8432 23.9924 26.9222 23.8813 26.9999 22.6513V11.459L22.0511 15.2575Z"
                fill="#34A853"
            />
            <path d="M9.94787 24.0001V15.0732L9.94019 15.0669L9.94787 24.0001Z" fill="#C5221F" />
            <path
                d="M9.94014 8.52404L8.37646 7.39382C5.60179 5.91001 5 9.17692 5 9.17692V11.4651L9.94014 15.0667V8.52404Z"
                fill="#C5221F"
            />
            <path d="M9.94019 8.52441V15.0671L9.94787 15.0734V8.53073L9.94019 8.52441Z" fill="#C5221F" />
            <path
                d="M5 11.4668V22.6591C5.07646 23.8904 6.15673 24.0003 6.15673 24.0003H9.94877L9.94014 15.0671L5 11.4668Z"
                fill="#4285F4"
            />
        </g>
        <defs>
            <filter
                id="filter0_d_9456_169739"
                x="-2"
                y="-1"
                width="36"
                height="36"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="1" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9456_169739" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9456_169739" result="shape" />
            </filter>
        </defs>
    </svg>
</template>

<script lang="ts" setup></script>
